import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { MeshBackgroundIcon } from '../svg/';
import styled from '../../styles/styled';
const MeshBackgroundWrapper = styled.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    left: '0',
    right: '0 ',
    top: '0',
    bottom: '0',
    minWidth: '1440px',
});
const ContentWrapper = styled.div({
    position: 'absolute',
    left: '0',
    right: '0 ',
    top: '0',
    bottom: '0',
});
const LinearGradientBackground = styled.div({
    position: 'relative',
    width: '100%',
    background: 'linear-gradient(90deg, #008CFF 0%, #00BFFF 57.47%, #23E5E5 100%)',
    height: '100vh',
});
const RadialGradientBackground = styled.div({
    background: 'rgba(0,160,255, .9)',
    borderRadius: '50%',
    zIndex: 0,
    boxShadow: '0 0 100px 100px rgba(0,160,255, .9)',
});
export const MeshBackground = ({ children }) => {
    return (_jsxs(LinearGradientBackground, { children: [_jsx(MeshBackgroundWrapper, { children: _jsx(MeshBackgroundIcon, {}) }), _jsx(ContentWrapper, { children: children })] }));
};
export const RadialFade = ({ children }) => {
    return _jsx(RadialGradientBackground, { children: children });
};
//# sourceMappingURL=index.js.map